import { getPoliciesApi } from '@/core/api/generatedApiClient';
import { rethrowHandledApiError } from '@/core/api/rethrowHandledApiError';
import type { CreatePolicyRequest, PolicyResponse, UpdatePolicyRequest } from '@/core/generated/api';

/** Предоставляет политики сервиса */
export const policyService = {
    /** Загружает список политик */
    async getAll(): Promise<PolicyResponse[]> {
        try {
            const response = await getPoliciesApi().apiV1PoliciesGetAllGet({});

            return response.data;
        } catch (error: unknown) {
            return rethrowHandledApiError(error);
        }
    },
    /** Загружает политику по идентификатору */
    async getById(id: string): Promise<PolicyResponse> {
        try {
            const response = await getPoliciesApi().apiV1PoliciesIdGet({ id });

            return response.data;
        } catch (error: unknown) {
            return rethrowHandledApiError(error);
        }
    },
    /** Создаёт политику */
    async create(data: CreatePolicyRequest): Promise<PolicyResponse> {
        try {
            const response = await getPoliciesApi().apiV1PoliciesCreatePolicyPost({ createPolicyRequest: data });

            return response.data;
        } catch (error: unknown) {
            return rethrowHandledApiError(error);
        }
    },
    /** Обновляет политику */
    async update(id: string, data: UpdatePolicyRequest): Promise<PolicyResponse> {
        try {
            const response = await getPoliciesApi()
                .apiV1PoliciesUpdatePolicyIdPut({
                    id,
                    updatePolicyRequest: data,
                });

            return response.data;
        } catch (error: unknown) {
            return rethrowHandledApiError(error);
        }
    },
    /** Деактивирует политику */
    async deactivate(id: string, comment?: string): Promise<void> {
        try {
            await getPoliciesApi()
                .apiV1PoliciesIdDelete({
                    id,
                    deleteRequest: { comment }
                });
        } catch (error: unknown) {
            rethrowHandledApiError(error);
        }
    },
};
